import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthView from "../views/AuthView";
import PrivateRoutes from "./private-routes";
import Layout from "../components/layout";
import StoresView from "../views/StoresView";
import CabinetsView from "../views/CabinetsView";
import BrandingView from "../views/BrandingView";
import KeysView from "../views/KeysView";
import PrintersView from "../views/PrintersView";
import SmsTemplatesView from "../views/SmsTemplatesView";

export default function AppRouter() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path='/' element={<AuthView />} />
          <Route element={<PrivateRoutes />} >
            <Route path='layout' element={<Layout />}>
                <Route index element={<StoresView />} />
                <Route path='stores' element={<StoresView />} />
                <Route path='cabinets' element={<CabinetsView />} />
                <Route path='printers' element={<PrintersView />} />
                <Route path='smstemplates' element={<SmsTemplatesView />} />
                <Route path='branding' element={<BrandingView />} />
                <Route path='keys' element={<KeysView />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
  );
}
